define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/NewController",
	"csi/_base/underscore",
	"csi/comm/PostRequest",
	"csi/comm",
	"csi/locale",
	"csi/xml"
], function(declare,lang,NewController,_,PostRequest,comm,locale,xml) {

	return declare(NewController, {
		successMsg: "",

		/**
		 * disable Save & Go since action can create multiple SKUs
		 */
		_canNavigate: function() {
			return false;
		},

		/***
		 * disallow Save & New in this case
		 */
		_canRepeat: function() {
			return false;
		},

		/**
		 * Write operation to MassCreateSKUs
		 */
		toWriter: function() {
			var req = this.m_action.m_request;
			var fd = this.m_formData;
			var w = this.m_writer;

			// be sure to turn server validation off since there is no current node
			this.bValidate = false;

			var type = this.m_action.m_typeNode;

			var cm = w.callMethod(req.m_module, req.m_operation)
				.addParameter("Products", xml.ATTR_REFLIST, fd.getFieldValue("Styles", true));

			// create new SKU node
			var cn = cm.createNode(null, type)  // cn is a ChangeNode
				.addParameter("SKUName", xml.ATTR_STRING, fd.getFieldValue("Node Name", true));

			_.forEach(fd.getFields(), function(field) {
				var fieldId = field.idParameter || field.m_id;
				if (fieldId && !field.m_bUsed) {
					cn.changeAttribute(fieldId, field.getType(), field.getValue());
				}
			}, this);

			w.addParameter("FaultTolerant", "true");
			w.addParameter("ReturnNodes", "Created");
			w.addParameter("ReturnCNLs", "None");
			w.addParameter("Fmt.Node.Info", "Min");
			w.addParameter("Fmt.Attr.Inc", "No");
			w.addParameter("Fmt.AC.Rights", "No");
		},

		postProcessSuccess: function() {
			var nodes = this.m_response.getNodes();
			var skusCreated = 0;
			_.forEach(nodes, function(node) {
				if (node.$Type == "SKU") {
					skusCreated++;
				}
			});

			// generate success message
			this.successMsg = locale.resource(skusCreated > 1 ? "SKUsCreated" : "SKUCreated", [skusCreated]);

			// display "Some Failed" message
			if (this.m_response.someFailed()) {
				this.displayErrorDialog({
					message: locale.resource("MassSKUsSomeFailedMessage"),
					onResponse: function() {}
				});
			}
			return this.inherited(arguments);
		},

		getSuccess: function() {
			return this.successMsg;
		}
	});
});